(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("cookie-utils"), require("es6-promise"), require("thd-event-emitter"), require("THDCustomer"));
	else if(typeof define === 'function' && define.amd)
		define(["cookie-utils", "es6-promise", "thd-event-emitter", "THDCustomer"], factory);
	else if(typeof exports === 'object')
		exports["THD_LOCALIZER"] = factory(require("cookie-utils"), require("es6-promise"), require("thd-event-emitter"), require("THDCustomer"));
	else
		root["THD_LOCALIZER"] = factory(root["cookie-utils"], root["es6-promise"], root["thd-event-emitter"], root["THDCustomer"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition